define(() => {
    "use strict";

    const States = {
        Active:            {name: "Active",            description: "Company users can log in normally, and published content is not affected"},
        LoginRestricted:   {name: "LoginRestricted",   description: "Company users cannot login, but published content is not affected"},
        ContentRestricted: {name: "ContentRestricted", description: "Company users can login as Spectator, but all published content is inactive"},
        Suspended:         {name: "Suspended",         description: "Company users are denied login and all published content is inactive"}
    };

    /**
     * Enumeration representing the company state, where the <tt>value</tt> is equal
     * to <tt>experienceModel.get("state")</tt>.
     *
     * @see data/CompanyModel
     * @class CompanyState
     * @author Antonio Lagrotteria
     */
    return {
        ACTIVE:             States.Active,
        LOGIN_RESTRICTED:   States.LoginRestricted,
        CONTENT_RESTRICTED: States.ContentRestricted,
        SUSPENDED:          States.Suspended,

        all: [States.Active, States.LoginRestricted, States.ContentRestricted, States.Suspended],

        /**
         * Returns the company state having the specified string value, or <tt>state</tt> itself.
         *
         * @param {String|{name:String,description:String}} state The state value, or an actual state.
         * @return {name:String,description:String}} The corresponding state; never null, will default to ACTIVE.
         */
        of(state) {
            const name = !state || typeof state === "string" ? state : state.name;

            return States[name || "Active"] || States.Active;
        }
    };
});



// WEBPACK FOOTER //
// ./src/shared/data/CompanyState.js